import React from 'react';

class NotFound extends React.Component {
	render() {
		return (
			<div className="NotFound">
				404
			</div>
    	);
  	}
}
export default NotFound;